import React, { useState, useEffect, useRef } from "react";
import { isMobile } from "react-device-detect";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";

import { TiArrowLeftThick, TiArrowRightThick } from "react-icons/ti";
import { FaCheck } from "react-icons/fa";

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const autoPlay = true;
  const autoPlayInterval = 10000;
  const images = [
    // "https://images.unsplash.com/photo-1570129477492-45c003edd2be?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1492889971304-ac16ab4a4a5a?q=80&w=3548&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1679797850019-3d0d8659a695?q=80&w=3538&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1564540579594-0930edb6de43?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1682888813913-e13f18692019?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://c3store.nyc3.digitaloceanspaces.com/ziel/crawlspace.jpg",
  ];
  const imagesMobile = [
    // "https://images.unsplash.com/photo-1480074568708-e7b720bb3f09?q=80&w=3548&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1492889971304-ac16ab4a4a5a?q=80&w=3548&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1679797850019-3d0d8659a695?q=80&w=3538&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://c3store.nyc3.digitaloceanspaces.com/ziel/crawlspace.jpg",
    "https://images.unsplash.com/photo-1564540579594-0930edb6de43?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://c3store.nyc3.digitaloceanspaces.com/ziel/showerpic2.jpg",
  ];
  const intervalRef = useRef(null);

  const resetAutoPlay = () => {
    if (autoPlay) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, autoPlayInterval);
    }
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    resetAutoPlay();
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    resetAutoPlay();
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
    resetAutoPlay();
  };

  useEffect(() => {
    if (autoPlay) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, autoPlayInterval);
    }
    return () => clearInterval(intervalRef.current); // Cleanup interval on unmount.
  }, [autoPlay, autoPlayInterval, images.length]);

  return (
    <div className="carousel" id="top">
      <ParallaxProvider>
        <Parallax speed={-20}>
          <div
            className="carousel-images"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {!isMobile && (
              <>
                {images.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Slide ${index + 1}`}
                    className="carousel-image"
                  />
                ))}
              </>
            )}
            {isMobile && (
              <>
                {imagesMobile.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Slide ${index + 1}`}
                    className="carousel-image"
                  />
                ))}
              </>
            )}
          </div>
        </Parallax>
      </ParallaxProvider>
      <button className="carousel-button prev" onClick={prevSlide}>
        <TiArrowLeftThick />
      </button>
      <button className="carousel-button next" onClick={nextSlide}>
        <TiArrowRightThick />
      </button>
      <div className="carousel-dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
      {isMobile && (
        <div className="floatinfo">
          <h1>ZIEL Indiana Has You Covered</h1>
          <div className="info1">
            <p>
              Quality Solutions, Exceptional Customer Service and Nothing but
              the Highest Standards
            </p>
            <a href="#contact">Get a Free Quote</a>
          </div>
        </div>
      )}
      {!isMobile && (
        <div className="floatinfo">
          <h1>ZIEL Indiana Has You Covered</h1>
          <div className="info1">
            <ul>
              <li>
                <FaCheck /> Insurance Claim Professionals
              </li>
              <li>
                <FaCheck /> Roofing & Siding
              </li>
              <li>
                <FaCheck /> Kitchen & Bath Remodels
              </li>
              <li>
                <FaCheck /> Interior & Exterior Painting
              </li>
            </ul>
            <ul className="ul2">
              <li>
                <FaCheck /> Preventative Maintenance
              </li>
              <li>
                <FaCheck /> Duct Cleaning, Repair & Installation
              </li>
              <li>
                <FaCheck /> Indoor Air Quality Enhancement
              </li>
              <li>
                <FaCheck /> Comfort System Repairs & Installation
              </li>
            </ul>
            <a href="#contact">Get a Free Quote</a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Carousel;
